import { StaticDateTimePicker } from '@mui/x-date-pickers'
import moment from 'moment'
import React from 'react'

import Button from '@/app/component/atom/button'

type Value = {
  from?: string
  to?: string
}

type DateTimeComponentProps = {
  name: string
  value?: Value
  disableFuture?: boolean
  onChange: (value: { name: string; value: Value }) => void
  onClear?: () => void
}

export default function DateTimeComponent({ name, value, disableFuture, onChange, onClear }: DateTimeComponentProps) {
  const [date, setDate] = React.useState<{
    from: moment.Moment | null
    to: moment.Moment | null
  }>({
    from: value && value.from ? moment(value.from) : moment().subtract(1, 'minute'),
    to: value && value.to ? moment(value.to) : moment(),
  })

  React.useEffect(() => {
    if (date.from?.isAfter(date.to)) {
      setDate({
        ...date,
        from: date.to,
      })
    }
  }, [date])

  return (
    <>
      <div style={{ display: 'flex' }}>
        <StaticDateTimePicker
          disableFuture={disableFuture}
          value={date.from}
          onChange={(val) => setDate({ ...date, from: val })}
          slots={{
            actionBar: () => null,
          }}
        />
        <StaticDateTimePicker
          disableFuture={disableFuture}
          value={date.to}
          onChange={(val) => setDate({ ...date, to: val })}
          slots={{
            actionBar: () => null,
          }}
        />
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          gap: '8px',
          paddingRight: '15px',
          paddingBottom: '15px',
        }}
      >
        {onClear && (
          <Button size="small" onClick={onClear}>
            Clear
          </Button>
        )}
        <Button
          size="small"
          variant="contained"
          color="primary"
          onClick={() =>
            onChange({
              name,
              value: {
                from: date.from?.toISOString(),
                to: date.to?.toISOString(),
              },
            })
          }
        >
          Save
        </Button>
      </div>
    </>
  )
}
